module.exports = __webpack_public_path__ + "media/food_safeties/header-098447b1.png";